document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll('[id^="smart-carousel-"]').forEach(wrapper => {

    const carousel = wrapper.querySelector(".smart-carousel");
    const track = wrapper.querySelector(".smart-carousel-track");
    let slides = Array.from(track.children);

    if (!carousel || slides.length < 2) return;

    const slidesDesktop = parseInt(wrapper.dataset.slidesDesktop, 10) || 4;
    const slidesMobile = parseInt(wrapper.dataset.slidesMobile, 10) || 1;
    const autoplay = wrapper.dataset.autoplay === "true";
    const autoplaySpeed = parseInt(wrapper.dataset.autoplaySpeed, 10) || 4000;

    let index = 0;
    let slideWidth = 0;
    let timer = null;
    let isAnimating = false;

    const slidesPerView = () =>
      window.innerWidth < 768 ? slidesMobile : slidesDesktop;

    /* ===== CLONE FOR LOOP ===== */
    const cloneCount = slidesPerView();
    slides.slice(-cloneCount).forEach(s => {
      const c = s.cloneNode(true);
      c.classList.add("clone");
      track.insertBefore(c, track.firstChild);
    });
    slides.slice(0, cloneCount).forEach(s => {
      const c = s.cloneNode(true);
      c.classList.add("clone");
      track.appendChild(c);
    });

    slides = Array.from(track.children);
    index = cloneCount;

    /* ===== SIZE ===== */
    function setSizes() {
      slideWidth = carousel.clientWidth / slidesPerView();
      slides.forEach(slide => {
        slide.style.minWidth = `${slideWidth}px`;
      });
      track.style.transition = "none";
      track.style.transform = `translateX(-${index * slideWidth}px)`;
    }

    /* ===== MOVE ===== */
    function goTo(i) {
      if (isAnimating) return;
      isAnimating = true;
      track.style.transition = "transform 0.45s ease";
      index = i;
      track.style.transform = `translateX(-${index * slideWidth}px)`;
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    track.addEventListener("transitionend", () => {
      track.style.transition = "none";
      const realCount = slides.length - cloneCount * 2;

      if (index >= realCount + cloneCount) {
        index = cloneCount;
      }
      if (index < cloneCount) {
        index = realCount + cloneCount - 1;
      }
      track.style.transform = `translateX(-${index * slideWidth}px)`;
      isAnimating = false;
    });

    /* ===== TOUCH ===== */
    let startX = 0;
    carousel.addEventListener("touchstart", e => {
      startX = e.touches[0].clientX;
      stopAutoplay();
    });

    carousel.addEventListener("touchend", e => {
      const dx = startX - e.changedTouches[0].clientX;
      if (Math.abs(dx) > 50) dx > 0 ? next() : prev();
      startAutoplay();
    });

    /* ===== AUTOPLAY ===== */
    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    wrapper.addEventListener("mouseenter", stopAutoplay);
    wrapper.addEventListener("mouseleave", startAutoplay);

    /* ===== NAV ===== */
    wrapper.querySelector(".next")?.addEventListener("click", () => {
      stopAutoplay(); next(); startAutoplay();
    });
    wrapper.querySelector(".prev")?.addEventListener("click", () => {
      stopAutoplay(); prev(); startAutoplay();
    });

    /* ===== RESIZE ===== */
    window.addEventListener("resize", setSizes);

    /* ===== INIT ===== */
    setSizes();
    startAutoplay();
  });
});



